module.exports = __webpack_public_path__ + "e5564902e2642c5e6e2e98e68a7d41f5.svg";